const createQuery = () => `
  ... on BrandLocationWidget {
    title
    items {
      locations {
        region
        statistic
      }
    }
  }
`

export default createQuery
